// =====================================================
// TIME AGO HELPER — ONEFORM
// Returns relative time in pt-BR (e.g., "há 2 dias")
// =====================================================

const MINUTE = 60;
const HOUR = 3600;
const DAY = 86400;

export function timeAgo(date: Date | string): string {
  const now = Date.now();
  const then = typeof date === 'string' ? new Date(date).getTime() : date.getTime();
  const diffSec = Math.floor((now - then) / 1000);

  if (diffSec < MINUTE) return 'agora mesmo';
  if (diffSec < HOUR) {
    const mins = Math.floor(diffSec / MINUTE);
    return `há ${mins} ${mins === 1 ? 'minuto' : 'minutos'}`;
  }
  if (diffSec < DAY) {
    const hours = Math.floor(diffSec / HOUR);
    return `há ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
  }
  const days = Math.floor(diffSec / DAY);
  return `há ${days} ${days === 1 ? 'dia' : 'dias'}`;
}
